import { apiSlice } from "./apiSlice";

export const tenderApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createTender: builder.mutation({
      query: (tenderData) => ({
        url: "/tenders/createTender",
        method: "POST",
        body: tenderData,
      }),
      invalidatesTags: ["Tender"],
    }),

    deleteTender: builder.mutation({
      query: (id) => ({
        url: `/tenders/deleteTender/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Tender"],
    }),

    updateTender: builder.mutation({
      query: ({ tenderData, id }) => ({
        url: `/tenders/updateTender/${id}`,
        method: "PATCH",
        body: tenderData,
      }),
      invalidatesTags: ["Tender"],
    }),

    getAllTenders: builder.query({
      query: ({ page = 1, search } = {}) => {
        const params = new URLSearchParams();
        params.append("page", page);
        if (search) params.append("search", search);

        return {
          url: `/tenders/getAllTenders?${params.toString()}`,
          method: "GET",
        };
      },
      providesTags: ["Tender"],
    }),
    getTenderById: builder.query({
      query: (id) => ({
        url: `/tenders/getTenderById/${id}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useCreateTenderMutation,
  useUpdateTenderMutation,
  useDeleteTenderMutation,
  useGetAllTendersQuery,
  useGetTenderByIdQuery,
} = tenderApi;
